module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"card_state_inactive":"Karte inaktiv"},"en":{"card_state_inactive":"Card inactive"}}')
  delete Component.options._Ctor
}
